export default __webpack_public_path__ + "static/sml-bf36e79590c4b94d8e493fc2c73722a4.png";